/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { fetchPatientsCCT } from 'legacy/containers/ApiUrls';

// Constants Types
import {
  CCT_PATIENTS_DATA_REQUEST,
  CCT_PATIENTS_DATA_SUCCESS,
  CCT_PATIENTS_DATA_FAILURE,
  CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  CCT_PATIENTST_CLEAR_PAGELIMIT,
  CCT_PATIENT_Provider_Id_UPDATE,
  CCT_PATIENT_Practice_Id_UPDATE,
  CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
  CCT_DEFAULT_FILTER_CLEAR,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxCCTPatientDataRequest = () => ({
  type: CCT_PATIENTS_DATA_REQUEST,
});
export const kardiRxCCTPatientDataSuccess = data => ({
  type: CCT_PATIENTS_DATA_SUCCESS,
  payload: data,
});
export const kardiRxCCTPatientDataFailure = () => ({
  type: CCT_PATIENTS_DATA_FAILURE,
});

export const getKardiaRxCCTPatientsData = (
  forceUpdate = false,
  pageLimt = 1000,
  page = 1,
  identifier,
) => (dispatch, getState) => {
  dispatch(kardiRxCCTPatientDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const practiceID =
        getState() &&
        getState().kardiaRx &&
        getState().kardiaRx.kardiaRxCCTPatients &&
        getState().kardiaRx.kardiaRxCCTPatients.practiceId
          ? getState() &&
            getState().kardiaRx &&
            getState().kardiaRx.kardiaRxCCTPatients &&
            getState().kardiaRx.kardiaRxCCTPatients.practiceId
          : '';
      const orderingPhysicianID =
        getState() &&
        getState().kardiaRx &&
        getState().kardiaRx.kardiaRxCCTPatients &&
        getState().kardiaRx.kardiaRxCCTPatients.providerId
          ? getState() &&
            getState().kardiaRx &&
            getState().kardiaRx.kardiaRxCCTPatients &&
            getState().kardiaRx.kardiaRxCCTPatients.providerId
          : '';

      const identifierReducer =
        (getState() &&
          getState().kardiaRx &&
          getState().kardiaRx.kardiaRxCCTPatients &&
          getState().kardiaRx.kardiaRxCCTPatients.selectedvalueOnSubmit &&
          getState().kardiaRx.kardiaRxCCTPatients.selectedvalueOnSubmit
            .patients) ||
        '';

      let identifierMrn;
      let queryKeyword;
      if (identifierReducer) {
        const valueArray = identifierReducer.split(' [');
        const mrnIdentifier =
          valueArray[1] && valueArray[1].substring(0, valueArray[1].length - 1);
        if (mrnIdentifier) {
          const mrnValue = mrnIdentifier.split(':')[1]; // get mrn serach
          identifierMrn = mrnValue;
          queryKeyword = 'mrn'
        } else {
          identifierMrn = identifierReducer; // get text serach
          queryKeyword = 'mrn'
        }
      } else {
        identifierMrn = '';
        queryKeyword = ''
      }

      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(
        dispatch(
          fetchPatientsCCT(
            teams[0].id,
            pageLimt,
            page,
            identifierMrn,
            practiceID,
            orderingPhysicianID,
            queryKeyword,
          ),
        ),
      );
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kardiRxCCTPatientDataSuccess(data));
    })
    .catch(err => {
      // console.log('getKardiaRxCCTPatientsData', err);
      dispatch(kardiRxCCTPatientDataFailure());
    });
};

export const handleOnRefreshClick = () => (dispatch, getState) => {
  dispatch(getKardiaRxCCTPatientsData(true));
};

export const searchSubmit = data => ({
  type: CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  payload: data,
});

export const clearPageLimit = data => ({
  type: CCT_PATIENTST_CLEAR_PAGELIMIT,
  payload: data,
});

export const practiceIdUpdate = id => ({
  type: CCT_PATIENT_Practice_Id_UPDATE,
  payload: id,
});

export const providerIdUpdate = id => ({
  type: CCT_PATIENT_Provider_Id_UPDATE,
  payload: id,
});

export const defaultFilterClear = () => ({
  type: CCT_DEFAULT_FILTER_CLEAR,
});

export const slectedValueONSubmitClear = () => ({
  type: CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
});



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatient/KardiaRxCCTPatientsActions.js